"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var graphql_tag_1 = require("graphql-tag");
var ApolloClient_1 = require("src/ApolloClient");
var UserCart_1 = require("src/bookstore/UserCart/UserCart");
var ErrorBoundary_1 = require("src/ErrorBoundary");
var CouponForm_1 = require("./CouponForm");
var ApplyCouponGQL = graphql_tag_1.default(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\nmutation ApplyCouponMutation($couponCode: String!) {\n  applyCouponToCart(couponCode: $couponCode) {\n      couponCodeError\n  }\n}\n"], ["\nmutation ApplyCouponMutation($couponCode: String!) {\n  applyCouponToCart(couponCode: $couponCode) {\n      couponCodeError\n  }\n}\n"])));
var ConnectedCouponForm = /** @class */ (function (_super) {
    __extends(ConnectedCouponForm, _super);
    function ConnectedCouponForm(props) {
        var _this = _super.call(this, props) || this;
        _this.onSubmit = function (couponCode) { return __awaiter(_this, void 0, void 0, function () {
            var result, data, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState({
                            disabled: true,
                            couponCodeError: undefined
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, ApolloClient_1.apolloClient.mutate({
                                mutation: ApplyCouponGQL,
                                variables: { couponCode: couponCode }
                            })];
                    case 2:
                        result = _a.sent();
                        if (!result.data) {
                            this.setState({ couponCodeError: 'Empty response when trying to apply coupon code.' });
                            return [2 /*return*/];
                        }
                        data = result.data;
                        if (data.applyCouponToCart.couponCodeError) {
                            this.setState({ couponCodeError: data.applyCouponToCart.couponCodeError });
                        }
                        else {
                            this.props.userCart.refetch();
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _a.sent();
                        this.props.displayMessage(e_1.message, 'error');
                        return [3 /*break*/, 5];
                    case 4:
                        this.setState({ disabled: false });
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        _this.state = {};
        return _this;
    }
    ConnectedCouponForm.prototype.render = function () {
        var _a = this.state, couponCodeError = _a.couponCodeError, _b = _a.disabled, disabled = _b === void 0 ? false : _b;
        return (React.createElement(CouponForm_1.default, { couponCodeError: couponCodeError, disabled: disabled, onSubmit: this.onSubmit }));
    };
    return ConnectedCouponForm;
}(React.Component));
exports.default = ErrorBoundary_1.withDisplayMessage(UserCart_1.withUserCart(ConnectedCouponForm));
var templateObject_1;
